import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";
import { ThemeProvider } from "@mui/material/styles";
import { ReactNode } from "react";

import theme from "../theme/theme";

interface WebShopThemeProviderProps {
    children: ReactNode;
}

export const WebShopThemeProvider = ({ children }: WebShopThemeProviderProps) => {
    return (
        <AppRouterCacheProvider>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </AppRouterCacheProvider>
    );
};
